module.exports = __webpack_public_path__ + "36e4c9b478c2e2adb339a76d819eed7e.woff2";